/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Position, Size, Tooltip } from "@blueprintjs/core"
import { useRef } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface ICardEditorProps {
   item: any
   cards: any[]
   i: number
   type: string
   sectionId?: ID
   cardsMeatId?: ID
   duplicate: () => void
   doDelete: () => void
   onPrev: () => void
   onNext: () => void
}
const CardEditor = (props: ICardEditorProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null) 
    
    return <div className='pe-item-editor pe-surface' ref={ref}> 
        {
            props.i > 0 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch previous")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID}  onClick={props.onPrev}>
                    <Icon icon="arrow-left" size={12} />
                </Button>
            </Tooltip>
        }
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Duplicate")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={props.duplicate}>
                <Icon icon="duplicate" size={12} />
            </Button>
        </Tooltip>
        
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Delete")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={props.doDelete}>
                <Icon icon="trash" size={12} />
            </Button>
        </Tooltip>
        {
            props.i < props.cards.length - 1 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch next")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={props.onNext}>
                    <Icon icon="arrow-right" size={12} />
                </Button>
            </Tooltip>
        }
    </div>
}
export default CardEditor
